/**
 * Investor Centre
 */
// eslint-disable-next-line simple-import-sort/imports
import { App } from '~/app';

import { defineAsyncComponent } from 'vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Investor Centre Component');
	 app.vueApp.component('investor-centre', defineAsyncComponent(async () => import("./InvestorCentre.vue")));

	 // Tabs
	 app.vueApp.component('asx-announcements', defineAsyncComponent(async () => import("./asx-announcements/AsxAnnouncements.vue")));
	 app.vueApp.component('property-portfolio', defineAsyncComponent(async () => import("./property-portfolio/PropertyPortfolio.vue")));
	 app.vueApp.component('results-reports', defineAsyncComponent(async () => import("./results-reports/ResultsReports.vue")));
	 app.vueApp.component('presentations', defineAsyncComponent(async () => import("./presentations/Presentations.vue")));
};
